import { render } from "./ExtraIncomeContent.vue?vue&type=template&id=dcfbae98"
import script from "./ExtraIncomeContent.vue?vue&type=script&lang=js"
export * from "./ExtraIncomeContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__